export * from "./daily-routine";
export * from "./pack-schoolbag";
export * from "./school-scenarios";

import { dailyRoutineLevels } from "./daily-routine";
import { packSchoolbagLevels } from "./pack-schoolbag";
import { schoolScenarioLevels } from "./school-scenarios";

export const habitsLevels = [
  ...packSchoolbagLevels,
  ...dailyRoutineLevels,
  ...schoolScenarioLevels
];
